﻿import * as layerTypes from '../../../../map/utils/layerTypes';
import * as paths from '../../../../map/utils/paths';
export default class GpkgExportControl {
    constructor(mapControl, layerSettingsHandler, resourcesHandler, classId, exportFormat, geometry, modalWrapper, rootURL) {
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.layerSettingsHandler = layerSettingsHandler;
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.exportFormat = exportFormat;
        this.geometry = geometry;
        this.modalWrapper = modalWrapper;
        this.rootURL = rootURL;
        this.exportWrapper = 'export-wrapper-' + this.classId;
        this.exportContainer = 'export-container-' + this.classId;
        this.cancelExportId = 'cancel-export-' + this.classId;
        this.saveExportId = 'save-export-' + this.classId;
        this.exportLayerTree = 'export-layer-tree-' + this.classId;
        this.exportLayerOptions = 'export-layer-options-' + this.classId;

        this.exportLayerAttributes = 'export-layer-attributes-' + this.classId;
        this.exportFileName = 'export-file-name-' + this.classId;
        this.init();
    }

    init() {
        $('#' + this.modalWrapper)[0].innerHTML = this._getExportTemplate();
        this._addEvents();
    }

    _getExportTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.exportWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0 col-12">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('ExportTitle').replaceAll('{format}', this.exportFormat) + `</label>
                            </div>
                            <div class="form-row mb-3 pl-4 pr-4 pt-3">
                                <div class="form-group col-6">
                                    <label class="form-label">` + this.resourcesHandler.get('ExportFileName') + `</label>
                                    <input class="form-control" id="` + this.exportFileName + `" type="text"/>
                                </div>
                            </div>
                            <div class="form-row col-12 pl-4">
                                <label class="form-label ml-2">` + this.resourcesHandler.get('ExportLayerSettings') + `</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-3" id="` + this.exportContainer + `">
                                <div class="form-group col-4 export-tree-container">
                                    <div id="` + this.exportLayerTree + `" class="export-layer-tree"></div>
                                </div>
                                <div class="form-group col-8 export-layer-options" id="` + this.exportLayerOptions + `">
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelExportId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveExportId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('Export') + `" type="button">` + this.resourcesHandler.get('Export') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _addEvents() {
        $('#' + this.cancelExportId).on('click', () => {
            this._hidePanel();
        });

        $('#' + this.saveExportId).on('click', () => {
            this._exportFile();
        });

        const now = new Date();

        const fileName = "export_" +
            now.getFullYear().toString() +
            String(now.getMonth() + 1).padStart(2, '0') +
            String(now.getDate()).padStart(2, '0') +
            "_" +
            String(now.getHours()).padStart(2, '0') +
            String(now.getMinutes()).padStart(2, '0') +
            String(now.getSeconds()).padStart(2, '0');
        $('#' + this.exportFileName).val(fileName);

        let layers = JSON.parse(JSON.stringify(this.mapControl.layerSettingsHandler.layers)).filter(x => (x.Type == 'ENTITY' && x.VisibleByDefault == true) || x.Type == 'GROUP');

        layers.forEach(item => {
            if (item.Items != null) {
                this.filterLayers(item);
            }

            item.checked = false;

            if (item.url != null) {
                delete item.url;
            }
        });

        layers = layers.filter(x => x.Type != 'GROUP' || x.items.length > 0);

        $('#' + this.exportLayerTree).kendoTreeView({
            dataSource: layers,
            checkboxes: {
                name: 'checked',
                checkChildren: true
            },
            loadOnDemand: false,
            dataTextField: "Title",
            dataValueField: "Id",
            select: (e) => {
                this._selectField(e);
            },
            template: (e) => {
                return this._getNodeTemplate(e);
            }
        });
    }

    _exportFile() {
        let exportFileName = $('#' + this.exportFileName).val().toLowerCase();

        exportFileName = exportFileName + '.gpkg';

        let url = this.rootURL + 'map/ExportMapLayers?keepFile=false&fileName=' + exportFileName;

        let data = {
            Format: this.exportFormat,
            IdMap: this.mapControl.mapId * 1,
            Srs: this.mapControl.map.getView().getProjection().getCode(),
            WktFilter: this.geometry,
            Layers: []
        }

        this._addLayers($('#' + this.exportLayerTree).data('kendoTreeView').dataSource.data(), data.Layers);
        showLoadingPanel();
        $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            async: true,
            contentType: "application/json; charset=utf-8",
            xhrFields: {
                responseType: "blob"
            },
            success: (blob, status, xhr) => {
                hideLoadingPanel();
                let filename = "";
                let disposition = xhr.getResponseHeader("Content-Disposition");
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                if (!filename) filename = exportFileName;


                let downloadUrl = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();

                setTimeout(function () {
                    window.URL.revokeObjectURL(downloadUrl);
                    document.body.removeChild(a);
                }, 100);
            },
            error: (e) => {
                hideLoadingPanel();
            }
        });
    }

    _addLayers(layers, data) {
        layers.forEach(layer => {
            if (layer.checked && layer.Type == 'ENTITY') {
                if (layer.exportOpts == null) {
                    layer.exportOpts = {
                    };
                }
                let layerData = {
                    IdLayer: layer.Id,
                    Options: layer.exportOpts
                }

                
                if (layer.Filters != null) {
                    layerData.Filter = JSON.stringify(layer.Filters.toJSON());
                }

                if (layer.Id < 0) {
                    layerData.IdExtConn = layer.IdExtConn;
                }

                layerData.Options.AttrList = [];

                if (layerData.Options.attributes != null && layerData.Options.attributes.length > 0 && layerData.Options.attributes[0].items != null) {
                    layerData.Options.attributes[0].items.forEach(attrItem => {
                        if (attrItem.checked) {
                            layerData.Options.AttrList.push(attrItem.Title);
                        }
                    }); 
                }

                delete layerData.Options.attributes;

                if (layerData.Options.AttrList.length == 0) {
                    delete layerData.Options.AttrList;
                }

                data.push(layerData);
            }

            if (layer.Type == 'GROUP' && layer.items != null && layer.items.length > 0) {
                this._addLayers(layer.items, data);
            }
        });
    }

    _selectField(node) {
        let item = node.sender.dataSource.getByUid(node.node.getAttribute('data-uid'));
        if (item.Type == 'ENTITY') {
            let url = this.rootURL + paths.MAP_ENTITY_GET_FIELDS + item.Entity.Id;

            if (item.exportOpts == null || item.exportOpts.attributes == null) {
                $.ajax({
                    type: "GET",
                    url: url,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        this._selectNode(node.node.getAttribute('data-uid'), item, result);
                    }
                });
            } else {
                this._selectNode(node.node.getAttribute('data-uid'), item, null);
            }
        }
    }

    _selectNode(uid, item, fields) {
        let template = `<div class="form-row">
                            <h4 class="export-layer-title col-12 mb-4">` + item.Title + `</h4>
                        </div>
                         <div class="form-row pl-3">
                            <label class="form-label col-12 mb-3">` + this.resourcesHandler.get('ExportAttributes') + `:</label>
                        </div>
                        <div class="form-row" id="` + this.exportLayerAttributes + `">

                        </div>`;

        $('#' + this.exportLayerOptions)[0].innerHTML = template;

        if (item.exportOpts == null) {
            item.exportOpts = {
            };
        }

        if (item.exportOpts.attributes == null) {
            let attributes = [{
                Title: this.resourcesHandler.get('AllAttributes'),
                Id: 0,
                checked: false,
                items: []
            }];

            if (fields != null) {
                fields.forEach(field => {
                    if (field.DataType != 'GEOMETRY') {
                        attributes[0].items.push({
                            Title: field.FieldName,
                            Id: field.Id,
                            checked: false
                        });
                    }
                });
            }

            item.exportOpts.attributes = attributes;
        }

        $('#' + this.exportLayerAttributes).kendoTreeView({
            dataSource: item.exportOpts.attributes,
            checkboxes: {
                name: 'checked',
                checkChildren: true
            },
            loadOnDemand: false,
            dataTextField: "Title",
            dataValueField: "Id",
            check: (e) => {
                let selection = e.sender.dataSource.getByUid(e.node.getAttribute('data-uid'));
                item.exportOpts.attributes[0].items.find(x => x.Id == selection.Id).checked = selection.checked;
            }
        });
    }

    _getNodeTemplate(node) {
        let layer = node.item;

        return this._getPrintLegendIcon(layer) + '<span class="export-layer-node">' + layer.Title + '</span>';
    }

    _getPrintLegendIcon(layer) {
        let template = ``;

        if (layer.Id == layerTypes.MEASUREMENTS) {
            template = `<span class="fal fa-ruler legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.DIMENSIONING) {
            template = `<span class="fal fa-arrows-h legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.REDLINE) {
            template = `<span class="fal fa-pencil-paintbrush legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Type == layerTypes.GROUP) {
            template = `<span class="fal fa-object-group legend-preview-icon" style="font-size: 1rem;"></span>`;
        } else if (layer.Type == layerTypes.GEOSERVICE) {
            if (layer.Geoservice.LegendUrl != null && layer.Geoservice.LegendUrl.trim() != '') {
                template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.PROXY_URL + this.mapId + '/' + layer.Fid.replaceAll('-', '') + layer.Geoservice.LegendUrl) + `"></img>`;
            } else {
                template = `<span class="fal fa-globe legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
            }
        }

        if (layer.IdDefaultStyle != null && layer.IdDefaultStyle > 0) {
            template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.IdDefaultStyle).replaceAll('{rule}', 0)) + `"></img>`;
        }

        return template;
    }

    filterLayers(layer) {
        let items = layer.Items.filter(x => (x.Type == 'ENTITY' && x.VisibleByDefault == true) || x.Type == 'GROUP');

        layer.items = items;

        layer.items.forEach(item => {
            if (item.Items != null) {
                this.filterLayers(item);
            }

            item.checked = false;

            if (item.url != null) {
                delete item.url;
            }
        });
        layer.checked = false;
        layer.items = layer.items.filter(x => x.Type != 'GROUP' || x.items.length > 0);
    }

    _hidePanel() {
        $('#' + this.modalWrapper)[0].innerHTML = '';
    }
}